export const index = {
  // 英文
  head: {
    cart: "Shopping cart",
    list: "List",
    msg: "Information",
    mine: "Individual",
    login: "Login",
    register: "Registration"
  },
  foot: {
    shop: "Mall",
    about: "About Us",
    news: "Press Center",
    cooperation: "Join And Cooperate",
    contact: "Contact Us",
    privacy: "Privacy Policy Dtatement",
    conditions: "General Terms Snd Conditions",
    questions: "Frequently Asked Questions"
  },
  address: {
    notAddress: "You Have Not Set A Default Shipping Address, Please Add It To Continue Checkout",
    addressee: "Recipient",
    title: "Address",
    mr: 'Mister',
    ms: 'Madam',
    phoneNumber: "Contact Information",
    detailedAddress: "Detailed Address",
    next: "Next step",
    shippingAddress: "Delivery Address",
    addAddress: "New Address",
    defaultAddress: "Default Address",
    edit: "Editor",
    delete: "Delete",
    setDefaultSuccess: "Default Setting Succeeded",
    pleaseRecipient: "Please Enter The Recipient",
    pleaseRecipient20: "Please set the recipient's name within 20 digits",
    pleaseContact: "Please Enter Contact Details",
    pleaseArea: "Please Select The Correct Address",
    regionSelectionProvince:"Please select a province",
    regionSelectionCity:"Please select city",
    regionSelectionArea:"Please select a district",
    pleaseDetailAddress: "Please Enter A Detailed Address",
    pleaseCode: "Please Enter The Zip Code",
    pleaseCodeTip:"Please Enter Zip Code (Please Fill In 0000)",
    code: "Postcode",
    editSuccess: "Modified Successfully",
    addSuccess: "Added Successfully",
  },
  account: {
    info: "Account Information",
    setOldPassword: "Old Password",
    setPassword: "Set Password * (enter 6-10 Units, Including Letters And Numbers)",
    setNewPassword: "Set A New Password",
    changePassword: "Change Password",
    setNickname: "Set Nickname",
    pleaseNickname: "Please Enter A Nickname",
    pleasePassword: "Please Enter A New Password",
    nickname: "Nickname",
    setAvatar: "Set Avatar",
    avatar: "Avatar",
    ok: "OK",
    setAvatarSuccess: "Profile Picture Set Successfully",
    editNicknameSuccess: "Modify Nickname",
    setNicknameSuccess: "Nickname Modified Successfully",
    pleasePasswordSuccess: "New Password Set Successfully",
    sureExit: "Are You Sure You Want To Quit?",
    tips: "Tip",
    exit: "Quit Successfully!"
  },
  login: {
    emailAddress: "Email Address *",
    youxing: "Mailbox",
    code: "CAPTCHA",
    ResendSeconds: "Resend In Seconds",
    getCode: "Get CAPTCHA",
    password: "Password",
    pleaseEmail: "Please Enter Your Mailbox",
    pleaseCode: "Please Enter The Verification Code",
    pleasePassword: "Please Enter Your Password",
    editSuccess: "Modified Successfully",
    sendSuccess: "Sent Successfully",
    PleaseMobileNumberAddress: "Please Enter Your Mobile Phone Number / Email Address",
    pleaseLastName: "Please Enter Your Last Name",
    LastName50: "Please Enter A Last Name Of Less Than 50 Characters",
    name50: "Please Enter A First Name Of Less Than 50 Characters",
    pwd20: "Please Enter A Password Of Less Than 20 Characters",
    pleaseName: "Please Enter A Name",
    pleasePhoneNumber: "Please Enter Your Mobile Phone Number",
    pleaseEmailAddress: "Please Enter Your Email Address",
    pleaseRightEmailAddress: "Please Enter Your Email Address",
    title: "Welcome To The HECOM Mattress",
    phone: "Mobile Phone Number / Email Address",
    login: "Login",
    pass: "Login Password",
    account: "No Account?",
    now: "Register Now",
    forget: "Forget Your Password",
    register: "Register A New Account",
    success: "Done",
    surname: "Last Name *",
    name: "Name *",
    tel: "Mobile Phone Number *",
    setPassword: "Set Password",
    email: "Email Address (Optional)",
    agree: "I Have Read And Agreed",
    policy: "User Registration Agreement And Privacy Policy",
    tickAgree: "Please Check The Agreement"
  },
  tab: {
    page: "Mall Home",
    classification: "Mall Classification",
    center: "Press Center",
    cooperation: "Join And Cooperate",
    about: "About Us",
    contact: "Contact Us"
  },
  pageSubtitle: {
    t1: "Recommended For You",
    t2: "Hot Today",
    t3: "More popular Recommendations",
    t4: "Thanksgiving Shocking Discount",
    t5: "Thanksgiving Shocking Discount"
  },
  contact: {
    title: "Contact Us",
    store: "Store Address",
    city: "Store Area",
    type: "Store Type",
    county: "Store County",
    plaCounty: "Please Select The County Where The Store Is Located",
    plaCity: 'Please Select The Region Where The Store Is Located',
    plaType: 'Please Select The Store Type',
    self: 'Self-operated Store',
    franchise: 'franchise Store',
    null: "No Store Information Yet",
    tips: "Please Inquire, We Will Serve You Wholeheartedly!",
    words: "Online Message",
    weChat: 'WeChat Online Customer Service',
    clickWords: "Click The Page To Enter The Message",
    telSubtitle: "Click To Contact WhatsApp Service",
    telWhatsApp: "WhatsApp Service",
    telTitle: "Service Telephone Number:",
    telNumber: "400 888 888",
    service: "Human Service Time:",
    serviceTimer: "Weekday 9:00~18:00",
    emailTitle: "Email",
    email: "Mailbox:",
    emailNumber: "XXXXX@XXX.XXX",
    emailTips: "Please Feel Free To Send Us An Email And We Will Give You A Timely Reply.",
    submit: "Save Submission",
    clickWeChat: "Click To Contact WeChat Customer Service"
  },
  about: {
    title: "About Us",
    tab1: "Company Introduction",
    tab2: "The Course Of Development",
    tab3: "Won The Honor",
  },
  apply: {
    title: "Apply For Membership",
    name: "Last Name",
    inputName: "Please Enter Your Name",
    tel: "Telephone",
    telephone: "Please Enter The Contact Number",
    telephoneRight: "Please Enter The Correct Contact Number",
    inputTel: "Please Enter The Contact Number",
    email: "Email",
    inputEmail: "Please Enter Your Email Address",
    emailRight: "Please Enter The Correct Email Address",
    area: "Land Area",
    success: "Submitted Successfully",
    applySuccess: "Successful Application",
    inputArea: "Please Enter The Region Where You Apply For Membership",
    submit: "Submit Application",
    textarea: "Please Enter The Content Of Your Message"
  },
  news: {
    title: "Press Center",
    read: "Read The Full Text",
    news: "Corporate News",
    media: "Media Check-in",
    HKpromotion: "Hong Kong, China Promotion",
    promotion: "Promotion In China",
    overseas: "Overseas Promotion",
  },
  classify: {
    null: "Null",
    bedding: "Mattress",
    hair: "Comb Your Hair",
    furniture: "Furniture",
    pillow: "Pillow",
    custom: "Custom Furniture",
    projects: "Special Project",
    article: "Bedding",
    hot: "Hot Selling Goods"
  },
  info: {
    account: "My Account",
    settings: "General Settings",
    seek: "Ask For Help",
    more: "More Information",
    orderRecord: "Order Record",
    refund: "Refund And Return",
    coupon: "Electronic Coupons",
    information: "Account Information",
    address: "Delivery Address",
    review: "Commodity Review",
    notice: "Discount Information Notification",
    language: "Language Switching",
    novice: "Novice Strategy",
    vip: "VIP Membership Program",
    problem: "Frequently Asked Questions",
    promotion: "Merchants To Join",
    contact: "Contact Us",
    privacy: "Privacy Policy Statement",
    conditions: "General Terms And Conditions"
  },
  message: {
    read: "Read",
    system: "System Message",
    notification: "Message Notification",
    reminder: "Shipping Reminder",
    payment: "Payment Succeeded",
    refund: "Refund And Return",
    customer: "Customer Service Message",
    unread: "Unread",
    sendGoods: "Shipping Reminder",
    issued: "Your Order Is Out Of Storage",
    detail: "Message Details",
    msgLoading: 'Verification Code Is Being Sent',
    click: 'Do Not Click Repeatedly'
  },
  cart: {
    market: 'Market Price',
    shopping: "Shopping Cart",
    subtotal: "Commodity Subtotal",
    promotional: "Promotional Discount",
    express: "Total Freight",
    total: "Shopping Cart Total",
    immediate: "Immediate Settlement",
    color: "Color:",
    price: "Unit Price:",
    number: "Quantity:",
    selectAll: "Select All",
    noGoodsShoppingCart: "Shopping Cart Has No Goods, That Is, Go To Choose Your Favorite Goods",
    go: "Go Shopping"
  },
  del: {
    tips: "Are You Sure You Want To Delete?",
    ok: "OK",
    remind: "Reminder",
    cancel: "Cancel",
    delSuccess: "Deleted Successfully",
    pleaseSelect: "Please Select Goods",
    affirm: "Confirm Receipt Of The Goods?",
    receivedSuccess: "Receiving Goods Successfully",
  },
  goods: {
    refund: "Return And Refund",
    orderTime: "Time To Place Order:",
    orderNo: "Order Number:",
    remainingTime: "Remaining Payment Time",
    size: "Dimensions And Specifications:",
    common: "Total",
    piece: "Piece",
    refunding: "In The Process Of Refund",
    color: "Color:",
    refundDetails: "Refund Details",
    go: "Go Shopping",
    noOrder: "No Order Information",
    orderNumber: "Order Number",
    refundCode: "Refund Code",
    refundReason: "Refund Reason",
    cargoDamage: "Damage To The Goods",
    refundAmount: "Refund Amount",
    applicationStatus: "Application Status",
    waitingApplication: "Waiting For Application",
    special: "Special Offer",
    sold: "Sold",
    best: "Best-Selling Goods",
    size: "Dimensions And Specifications",
    color: "Color Of Goods",
    number: "Quantity",
    add: "Add To The Shopping Cart",
    list: "Add To My List",
    special: "Customized",
    detail: "Detailed Introduction",
    review: "Product Reviews"
  },
  order: {
    order: "Personal Order",
    all: "All",
    pending: "To Be Paid",
    shipped: "To Be Shipped",
    received: "Waiting For Receipt",
    commented: "To Be Commented",
    time: "Time To Place Order:",
    no: "Order Number:",
    writeComments: "Write Comments",
    cancellation: "Cancel Order",
    common: "Total",
    piece: "Piece",
    color: "Color:",
    paymentTime: "Remaining Payment Time",
    size: "Dimensions And Specifications:",
    go: "Go Shopping",
    noOrder: "No Order Information",
    score: "Product Rating",
    sayScore: "Please Tell Me About The Use Of Evaluation!" ,
    confirmReceipt: "Confirm Receipt Of Goods",
    continuePay: "Continue To Pay",
    deleteOrder: "Delete Order",
    refundOnly: "Refund Only",
    refundTips: "Did Not Receive The Goods, The Goods And The Seller Agreed Not To Return The Goods, Only A Refund",
    returnRefund: "Return And Refund",
    goodsReturned: "The Goods Have Been Received And Need To Be Returned And Exchanged",
    cargoStatus: "Status Of Goods",
    pleaseSelect: "Please Select",
    refundReason: "Refund Reason",
    refundAmount: "Refund Amount",
    numberApplications: "Number Of Applications",
    replenish: "Supplementary Reasons And Vouchers",
    pleaseRefundReason: "Please Enter The Reason For The Refund",
    saveSubmit: "Save Submission",
    pleaseSelectCargoStatus: "Please Select The Status Of The Goods",
    PleaseSelectRefundReason: "Please Choose The Reason For The Refund",
    refundReturnOption: "Refund And Return Option",
    commentSuccess: "Comment Successful",
    cancelSuccee: "Refund Cancelled Successfully",
    sureCancelRefund: "Are You Sure You Want To Cancel The Refund?",
    sureDeleteOrder: "Confirm to delete the order?",
    sureCancelOrder: "Confirm To Cancel The Order?",
    CancelSuccess: "Cancel Successfully"
  },
  orderDetail: {
    orderReceived: "Order To Be Received",
    size: "Dimensions And Specifications:",
    color: "Color:",
    price: "Unit Price:",
    number: "Quantity:",
    receiptInfo: "Receiving Information",
    consignee: "Consignee:",
    contactNumber: "Telephone Number:",
    shippingAddress: "Receiving Address:",
    orderNo: "Order Number:",
    orderTime: "Time To Place Order:",
    subtotalGoods: "Commodity Subtotal",
    promotional: "Promotional Discount",
    confirm: "Confirm Receipt Of Goods",
  },
  orderStatusTxt: {
    cancel: "Cancelled",
    pay: "To Be Paid",
    sendGoods: "To Be Shipped",
    received: "Waiting For Receipt",
    evaluated: "To Be Evaluated",
    completed: "Completed",
    refunded: "Refunded",
    refundFailed: "Refund Failed",
    cancel: "Cancelled",
    cancel: "Cancelled",
  },
  statusTxt: {
    cancel: "Cancelled",
    refundProcessing: "Cefund Processing",
    refundProcessing: "Cefund Processing",
    refunded: "Refunded",
    refundRejected: "refund Has Been Refused",
  },
  goodsDeatil: {
    overview: "Commodity Introduction:",
    specialPrice: "Special Offer",
    length: "Length",
    PleaseLength: "Please Enter The Content Length",
    width: "Width",
    pleaseWidth: "Please Enter The Content Width",
    height: "Height",
    price: "Price:",
    lengthMust: "Length Must Be Greater Than 0",
    widthMust: "Width Must Be Greater Than 0",
    addListSuccess: "Successfully Added To My List!",
    addshoppingSuccess: "Join The Shopping Cart Successfully!",
    sold: "Sold",
    dimensions: "Dimensions And Specifications",
    itemColor: "Color Of Goods",
    number: "Quantity",
    addCart: "Add To The Shopping Cart",
    addList: "Add To My List",
    info: "Detailed Introduction:",
    userReviews: "Product Reviews",
    allUserReviews: "All Product Reviews",
    comments: "Then Comment",
    writeComments: "Write Comments",
    hotGoods: "Best-selling Goods",
    specialOrder: "Customized",
    pleaseSelect: "Please Select",
    size: "Size",
    unit: "(in feet)",
    height: "Height",
    color: "Color",
    score: "Product Rating",
    delivery: 'Delivery/Return',
    sayScore: "Please Tell Me About The Use Of Evaluation!"
  },
  goodsConfirmOrder: {
    title: "Delivery Information",
    addressee: "Recipient",
    replace: "Change Delivery Information",
    color: "Color:",
    receiptInfo: "Receiving Information",
    consignee: "Consignee:",
    dimensions: "Dimensions And Specifications",
    shippingAddress: "Receiving Address:",
    goodsList: "Commodity List",
    orderDetail: "Order Details",
    subtotalGoods: "Commodity Subtotal",
    promotional: "promotional Discount",
    expenses: "Distribution Expenses",
    total: "Shopping Cart Total",
    submit: "Submit Order",
  },
  payment: {
    cashier: "Cashier",
    success: "The Order Has Been Submitted Successfully, Please Pay As Soon As Possible",
    orderNo: "Order Number:",
    amount: "Amount To Be Paid:",
    tips1: "Please Be There",
    tips2: "payment Is Completed Within, Otherwise The Order Will Be Closed Automatically",
    paymentMethod: "Payment Method",
    more: "More Payment Methods",
    next: "Next Step",
    min: 'minute',
    sec: 'second'
  },
  coupon: {
    heima: "Hong Kong HECOM",
    coupons: "Electronic Coupons",
    notUsed: "Not Used",
    used: "Used",
    expired: "Expired",
    toUse: "To Use",
    full: "Man",
    rebate: "Rebate",
    couponMethod: "Get Coupons",
    noCoupon: "No Coupons For The Time Being",
    drawSuccess: "Get It Successfully",
    draw: "Received",
    receive: "Receive",
    ranout:"RanOut",
  },
}


//////////////////
// WEBPACK FOOTER
// ./common/lang/en.js
// module id = 9Kd7
// module chunks = 27